import React, { useState } from 'react';
import ModalityMeasurementSelection from './ModalityMeasurementSelection';
import { useDispatch } from 'react-redux';
import inputStyles from '../views/program-management/ProgramManagement.module.css';
import styles from './ManagementDropdownCard.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { EnrollmentDropdowns } from './EnrollmentDropdown';
import { initStartTime, convertStartTime } from '../utils/programUtils';
import managementStyles from '../views/ManagementPages.module.css';

const DeviceSetupCard = (props) => {
    const {
        id,
        modalities,
        dataList,
        setCardData,
        setModality,
        modalityState,
        errorShowing,
        disabled,
        viewOnly,
        allDevices
    } = props;

    const dispatch = useDispatch();
    const data = dataList.find((item) => item.deviceId === id);
    const [selectedModality, setSelectedModality] = useState(modalities[0] ?? 0);
    const [startTimeView, setStartTimeView] = useState(data ? initStartTime(data.startTime) : { startInt: 1, interval: "AM" });

    // Early return if data is not available
    if (!data) {
        return <div>Loading device data...</div>;
    }

    const handleModalitySelection = (m) => {
        setSelectedModality(m);
    };

    let frequencyErrorMessage = "Please provide a valid interval: \n Day: 1-365, Min: 1-60, Hour: 1-24"
    let frequencyErrorShowing = errorShowing.showing && (data.frequency <= 0 ||
        (data.interval === "Day" && data.frequency > 365) ||
        (data.interval === "Min" && data.frequency > 60) ||
        (data.interval === "Hour" && data.frequency > 24)
    );

    let startTimeErrorMessage = "Please provide a valid start time"
    let startTimeErrorShowing = errorShowing.showing && data.startTime === "";

    const handleStartTime = (e) => {
        let name = e.target.id;
        let value = e.target.value;
        if (name === "startInt") {
            value = Number(value);
        }
        setStartTimeView({
            ...startTimeView,
            [name]: value
        });

        // Calculate ISO string and dispatch action
        const isoString = convertStartTime(
            name === "startInt" ? value : startTimeView.startInt,
            name === "interval" ? value : startTimeView.interval
        );
        dispatch(setCardData({ ...data, startTime: isoString }));
    };

    const handleFrequency = (e) => {
        let value = e.target.value;
        if (value === "" || isNaN(Number(value))) {
            value = ""; // Reset if empty or invalid
        } else {
            value = Number(value); // Convert to number
        }
        let tempData = { ...data };
        tempData['frequency'] = value;
        if (data["interval"] === "") {
            tempData['interval'] = "Day";
        };
        dispatch(setCardData(tempData));
    };

    const handleIntervalChange = (e) => {
        let tempData = { ...data };
        tempData['interval'] = e.target.value;
        dispatch(setCardData(tempData));
    };

    return (
        <div style={{ display: "flex", flexDirection: "column", gap: "5px", width: "100%", height: "100%" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "10px", width: "100%", height: "100%", padding: "10px 0 0 20px" }}>
                {modalities.some(modality => modality.modalityId === 11) &&
                    <div className={managementStyles.warningMessageContainer}>
                        {"This device is intended for patients requiring glucose monitoring as determined by clinical need (e.g., diabetes, prediabetes, or other carbohydrate metabolism disorders)."}
                    </div>
                
                }
                <span className={styles.Interval}>Interval</span>
                <div className={styles.IntervalRow}>
                    <span className={styles.Label} style={{ width: "130px" }}>
                        {`Start Time${!viewOnly ? "*" : ":"}`}
                    </span>
                    {viewOnly ?
                        <div>
                            {`${startTimeView.startInt} ${startTimeView.interval}`}
                        </div>
                        :
                        <>
                            <select 
                                className={inputStyles.InputStyling} 
                                style={(errorShowing.showing && data.startTime === "") ? { border: "1px solid red", width: "70px" } : { width: "70px" }}
                                id="startInt"
                                disabled={disabled}
                                defaultValue={startTimeView.startInt}
                                onChange={handleStartTime}
                            >
                                {EnrollmentDropdowns.hourIntervals.map((item, index) => (
                                    <option key={index} value={item.value}>
                                        {item.label}
                                    </option>
                                ))}
                            </select>
                            <select className={inputStyles.InputStyling}
                                style={(errorShowing.showing && data.startTime === "") ? { border: "1px solid red", width: "120px" } : { width: "120px" }}
                                id="interval"
                                disabled={disabled}
                                defaultValue={startTimeView.interval}
                                onChange={handleStartTime}
                            >
                                {EnrollmentDropdowns.timeIntervals.map((item, index) => (
                                    <option key={index} value={item.value}>
                                        {item.label}
                                    </option>
                                ))}
                            </select>
                        </>}
                </div>
                {startTimeErrorShowing &&
                    <span className={inputStyles.ValidationMessage}>
                        {startTimeErrorMessage}
                    </span>
                }
                <div className={styles.IntervalRow}>
                    <span className={styles.Label} style={{ width: "130px" }}>
                        {`Repeat Every${!viewOnly ? "*" : ":"}`}
                    </span>
                    {viewOnly ?
                        <div>
                            {`${data.frequency} ${data.interval}`}
                        </div>
                        :
                        <>

                            <input className={inputStyles.InputStyling}
                                style={(errorShowing.showing && frequencyErrorShowing) ? { border: "1px solid red", width: "70px" } : { width: "70px" }}
                                value={data.frequency}
                                id="frequency"
                                maxLength={3}
                                disabled={disabled}
                                onChange={handleFrequency}
                            ></input>
                            <select className={inputStyles.InputStyling}
                                style={(errorShowing.showing && frequencyErrorShowing) ? { border: "1px solid red", width: "120px" } : { width: "120px" }}
                                disabled={disabled}
                                id="interval"
                                value={data.interval}
                                onChange={handleIntervalChange}
                            >
                                {EnrollmentDropdowns.repeatIntervals.filter((item)=> item.value !== "Min").map((item, index) => (
                                    <option key={index} value={item.value}>
                                        {item.label}
                                    </option>
                                ))}
                            </select>
                        </>
                    }
                </div>
                {frequencyErrorShowing &&
                    <span className={inputStyles.ValidationMessage}>
                        {frequencyErrorMessage}
                    </span>
                }
                <div className={styles.IntervalRow}>
                    <span className={styles.Label} style={{ width: "130px" }}>
                        {`Reading Types${!viewOnly ? "*" : ":"}`}
                    </span>
                    {viewOnly ?
                        <div>
                            {data.readingType}
                        </div>
                        :
                        <select className={inputStyles.InputStyling}
                            style={{ width: "200px" }}
                            id="readingType"
                            value={data.readingType}
                            disabled={disabled}
                            onChange={(e) => dispatch(setCardData({ ...data, readingType: e.target.value }))}
                        >
                            {EnrollmentDropdowns.readings.map((item, index) => (
                                <option key={index} value={item.value}>
                                    {item.label}
                                </option>
                            ))}
                        </select>
                    }
                </div>
            </div>
            <div className={styles.ModalitiesList}>
                {modalities.map((item, index) => (
                    <div key={index} onClick={() => handleModalitySelection(item)} 
                    style={errorShowing.modalityErrors.some(id => id === item.deviceModalityId) ? {color: "#DC3545"} : {}}
                    className={selectedModality.deviceModalityId===item.deviceModalityId ? styles.ModalityLabelActive : styles.ModalityLabel}
                    >
                        {item.modalityName}
                    </div>
                ))}
            </div>
            <div>
                {selectedModality.modalityId === 11 ? (
                    <div style={{padding:"10px 20px", fontSize:"12px"}}>
                        Threshold and goal settings are unavailable for this modality.
                    </div>
                ) : (
                    <ModalityMeasurementSelection
                        deviceId={id}
                        deviceModalityId={selectedModality.deviceModalityId}
                        setModality={setModality}
                        dataList={modalityState}
                        disabled={disabled || viewOnly}
                        errors={errorShowing}
                        allDevices={allDevices}
                    />
                )}
            </div>
            {errorShowing.modalityShowing && errorShowing.deviceIdErrors.some(item => item === id) &&
                <div className={inputStyles.ValidationMessageContainer}>
                    <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" size="xs" style={{ color: "red" }} />
                    <span className={inputStyles.ValidationMessage}>
                        {errorShowing.modalityMessage}
                    </span>
                </div>
            }
            <div style={{ padding: "1px" }}></div>
        </div>
    )
}

export default DeviceSetupCard;